import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ButtonBase, Typography } from '@material-ui/core';
import { DelaStarCalculatingIcon } from '~/modules/common/components/Icons';
import useStyles from './useStyles';

export const ResourceMatchItemCalculating = ({
  dataQeId,
  resourceRequest,
  setAnchorEl,
  setPopoverResourceRequest,
  narrow = false
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const handlePopover = useCallback(
    event => {
      setAnchorEl(event.currentTarget);
      setPopoverResourceRequest(resourceRequest);
    },
    [setAnchorEl, setPopoverResourceRequest, resourceRequest]
  );

  return (
    <div
      data-qe-id={
        dataQeId ? `${dataQeId}_ResourceMatchItemCalculating` : undefined
      }
      className={classes.itemRoot}
    >
      <ButtonBase className={classes.itemButton} onClick={handlePopover}>
        <div className={classes.itemInfo}>
          <div className={classes.itemContainer}>
            <div className={classes.itemTextContainer}>
              {narrow ? (
                <>
                  <DelaStarCalculatingIcon />
                  <Typography variant="body2" color="textSecondary">
                    {formatMessage({
                      id: 'resourceMatchItem.calculating'
                    })}
                  </Typography>
                </>
              ) : (
                <>
                  <DelaStarCalculatingIcon
                    className={classes.itemDelaStarIconSmall}
                  />
                  <Typography variant="caption" color="textSecondary">
                    {formatMessage({
                      id: 'resourceMatchItem.resourceMatcher'
                    })}
                  </Typography>
                </>
              )}
            </div>
            {!narrow && (
              <div className={classes.itemTextContainer}>
                <Typography variant="body2" color="textSecondary">
                  {formatMessage({
                    id: 'resourceMatchItem.calculating'
                  })}
                </Typography>
              </div>
            )}
          </div>
        </div>
      </ButtonBase>
    </div>
  );
};

ResourceMatchItemCalculating.propTypes = {
  dataQeId: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired,
  setAnchorEl: PropTypes.func.isRequired,
  setPopoverResourceRequest: PropTypes.func.isRequired,
  narrow: PropTypes.bool
};

export default ResourceMatchItemCalculating;
